import { FC } from "react";

import {
  BookingPrepareConflictErrorType,
  IBookingPrepareConflict,
} from "@ryde/shared";

import { RejectedBookingsUpload } from "./rejected-bookings-upload";
import { RejectedBookingsUploadSimple } from "./rejected-bookings-upload-simple";

interface IResolveRejectedBookingUploadTableProps {
  errorType: IBookingPrepareConflict["errorType"];
}

export const ResolveRejectedBookingUploadTable: FC<
  IResolveRejectedBookingUploadTableProps
> = ({ errorType }) => {
  switch (errorType) {
    case BookingPrepareConflictErrorType.passengerNotFoundByCode: {
      return <RejectedBookingsUpload />;
    }

    default: {
      return <RejectedBookingsUploadSimple />;
    }
  }
};
